import services from "@/config/services";
import FileManager from "@/services/ask-file-manager/index.js";

export default class UtilityService {
  constructor(http, eventBus) {
    this.http = http;
    this.eventBus = eventBus;
    this.baseUrl = `${services.ask_api.url}/management`;
    this.filemanager = new FileManager();
    this.baseUrlFlussi = `${services.ask_base_flussi.url}`;
    this.basePraticheUrl = `${services.ask_pratiche.url}`
  }

  async getAgenti(direct = 0) {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/agenti/${direct}`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getAgentiPerGettoni(direct = 0) {
    let items = [];

    const url = `${this.baseUrl}/utility/agenti-per-gettoni/${direct}`;

    try {
      let res = await this.http.get(url);
      
      if (res.data.meta && res.data.meta.success === false) {
        throw new Error(res.data.meta.status.message);
      }
      
      items = res.data.data || [];
      
    } catch (err) {
      console.error('Errore completo:', err);
      this.eventBus.emit("data-load-error", {
        message: err.message || 'Errore nel recupero degli agenti',
        url
      });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: items.length,
        success: items.length > 0
      };
    }
  }


  async getAgenzie() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/agenzie`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getSubAgenti(idAgente) {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/subagenti/${idAgente}`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async canUserChangeSospendibilePreavvisabile() {

    let url = `${this.baseUrl}/clienti/sospendibile-prevvisabile/permessi`;

    try {
      let res = await this.http.get(url);
      return res.data;
    } catch (error) {
      this.eventBus.emit("data-load-error", { message: error, url });
    }
  }

  async getComuni() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/comuni`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getComuniConCap() {
    const url = `${this.basePraticheUrl}/get-cities/null`;

    try {
      const res = await this.http.get(url);
      return { items: res.data || [] };
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
      return { items: [] };
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async getToponimi() {
    const url = `${this.basePraticheUrl}/get-toponimi`;

    try {
      const res = await this.http.get(url);
      return { items: res.data || [] };
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
      return { items: [] };
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async getDistributoriEnergia() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/distributori-energia`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getGiorniScadenza() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/giorni-scadenza`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getCodiciIva() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/codici-iva`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getListaRappresentanti() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-rappresentanti`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getListaRappresentantiAutoComplete(term) {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-rappresentanti-autocomplete`;

    try {
      let res = await this.http.get(url, {
        params: {
          term,
        },
      });

      res = res.data;
      items = Array.isArray(res.data) ? res.data : res;
      totalItems = res.meta && typeof res.meta.total_items !== 'undefined'
        ? res.meta.total_items
        : items.length;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getListaClienti() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-clienti`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getListaRappresentantiFromAgenti(idAgente) {
    let items = [];

    const url = `${this.baseUrl}/utility/lista-rappresentanti-from-agenti/${idAgente}`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = Array.isArray(res) ? res : (res.data || []);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }
  async getSearchedOfferta(searched){
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/offerta/${searched}`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getListaOfferte() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-offerte`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }
  async getOfferteAgent(id){
    let items = []
    const url = `${this.basePraticheUrl}/get-offerte-for-agent-${id}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getListaOfferteAttive() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/lista-offerte-attive`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiAllegato() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-allegato`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTypeAccisa() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-accisa`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async downloadScansioni(item) {
    const url = `${this.baseUrl}/utility/scansioni/download/pdf`;
    try {
      let res = await this.http({
        url,
        method: "POST",
        data: { data: item },
        responseType: "blob",
      });

      this.filemanager.download(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async openScansioni(item) {
    const url = `${this.baseUrl}/utility/scansioni/download/pdf`;
    try {
      let res = await this.http({
        url,
        method: "POST",
        data: { data: item },
        responseType: "blob",
      });

      this.filemanager.open(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async downloadDocumenti(item) {
    const url = `${this.baseUrl}/utility/documenti/download`;
    try {
      let res = await this.http({
        url,
        method: "POST",
        data: { data: item },
        responseType: "blob",
      });

      this.filemanager.download(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async openDocumenti(item) {
    const url = `${this.baseUrl}/utility/documenti/download`;
    try {
      let res = await this.http({
        url,
        method: "POST",
        data: { data: item },
        responseType: "blob",
      });

      this.filemanager.open(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async uploadDocumenti(fd) {
    const url = `${this.baseUrl}/utility/documenti/upload`;
    const settings = { headers: { "content-type": "multipart/form-data" } };

    try {
      const res = await this.http.post(url, fd, settings);
      if (res.data.success) {
        this.eventBus.emit("data-load-success", { message: res.data.msg });
      } else {
        this.eventBus.emit("data-load-error", { message: res.data.msg });
      }
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async sendPushNotice(fd) {
    const url = `${this.baseUrl}/push-notification`;
    let item;
    try {
      await this.http.post(url, fd).then((res) => {
        item = res.data;
      });
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
    return { item };
  }

  async getTipiCliente() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-cliente`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiCategoriaCliente() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-categoria-cliente`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiAliquotaIva() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-aliquota-iva`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiMetodoPagamento() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-metodo-pagamento`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiMetodoPagamentoCliente() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-metodo-pagamento-cliente`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiMisuratore() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-misuratore`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiContrattoVendita() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-contratto-vendita`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiFatturazione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-fatturazione`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiTariffazione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-tariffazione`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiTensione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-tensione`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiOfferta() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-offerta`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiPeriodoFatturazione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-periodo-fatturazione`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiAcquisizione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-acquisizione`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiResidente() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-residente`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiRid() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-rid`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiSpedizione() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-spedizione`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async geTipiStatoContratto() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-stato-contratto`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }
  async geTipiStatoFornitura() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-stato-fornitura`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async geMotivazioniStatoContrattoKo() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/motivazioni-stato-contratto-ko`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiStima() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-stima`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getTipiUso() {
    let items = [];
    let totalItems = 0;

    const url = `${this.baseUrl}/utility/tipi-uso`;

    try {
      let res = await this.http.get(url);
      res = res.data;

      items = res.data;
      totalItems = res.meta.total_items;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      };
    }
  }

  async getFatturaVoci() {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura-voci`;

    try {
      let res = await this.http.get(url);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async downloadTemplateFatturaVociMassivo() {
    const url = `${this.baseUrl}/utility/fattura-voci/template/massivo/download`;
    try {
      let res = await this.http({
        url,
        method: "GET",
        // data: {data:item},
        responseType: "blob",
      });

      this.filemanager.download(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async getFatturaSezioni() {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura-sezioni`;

    try {
      let res = await this.http.get(url);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async getFatturaTypePrezzo() {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura-type-prezzo`;

    try {
      let res = await this.http.get(url);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async addVoceInFattura(item, type) {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura/voce/create`;

    try {
      let res = await this.http.post(url, {
        data: item,
        type: type,
      });

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async addConsumo(newConsumo, podCode) {
    const url = `${this.baseUrl}/utility/fattura/voce/createConsumoDistributore`;

    try {
      let res = await this.http.post(url, { ...newConsumo, podCode });

      if (res.status === 200) {
        return {
          success: true,
          message: "Consumo aggiunto con successo",
        };
      } else {
        throw new Error("Errore durante l'aggiunta del consumo");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      return {
        success: false,
        message: `Errore durante l'aggiunta del consumo: ${error.message}`,
      };
    }
  }

  async addConsumoGas(newConsumo, pdrCode) {
    const url = `${this.baseUrl}/utility/fattura/voce/createConsumoDistributoreGas`;
  
    try {
      let res = await this.http.post(url, { ...newConsumo, pdrCode, saveconsumo: true });
      console.log("Response:", res);
  
      if (res.status === 200 && res.data.success) {
        return {
          success: true,
          message: "Consumo aggiunto con successo",
          data: res.data.data
        };
      } else {
        throw new Error(res.data.message || "Errore durante l'aggiunta del consumo");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      return {
        success: false,
        message: `Errore durante l'aggiunta del consumo: ${error.message}`,
      };
    }
  }
  
  async getConsumoGas(code) {
    const url = `${this.baseUrl}/utility/fattura/voce/getConsumoDistributoreGas`;
  
    try {
      let res = await this.http.post(url, { code });
      console.log("Response:", res);
  
      if (res.status === 200) {
        return {
          success: true,
          items: res.data.items,
          message: "Dati del consumo recuperati con successo",
        };
      } else {
        throw new Error("Errore durante il recupero dei dati del consumo");
      }
    } catch (error) {
      console.error("Errore occorso:", error);
      return {
        success: false,
        message: `Errore durante il recupero dei dati del consumo: ${error.message}`,
      };
    }
  }
  
  
  

  async getConsumo(podId) {
    const url = `${this.baseUrl}/utility/fattura/voce/getConsumoDistributore`;
  
    try {
      let res = await this.http.post(url, { podId: podId },);
      
  
      if (res.status === 200 && res.data.success) {
        return {
          success: true,
          items: res.data.items || [],
          message: "Dati del consumo recuperati con successo",
        };
      } else {
        return {
          success: false,
          message: res.data.message || "Errore durante il recupero dei dati del consumo",
        };
      }
    } catch (error) {
      console.error("Errore occorso:", error);
      return {
        success: false,
        message: `Errore durante il recupero dei dati del consumo: ${error.message}`,
      };
    }
  }

  async addVoceInFatturaFromFile(file, type) {
    let items = [];
    const settings = { headers: { "content-type": "multipart/form-data" } };
    const url = `${this.baseUrl}/utility/fattura/voce/massivo/create`;
    let fd = new FormData();
    fd.append("type", type);
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }

    try {
      let res = await this.http.post(url, fd, settings);
      items = res.data;
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async previewFatturaVociMassivoFromFile(file, type) {
    let items = [];
    const settings = { headers: { "content-type": "multipart/form-data" } };
    const url = `${this.baseUrl}/utility/fattura/voce/massivo/preview`;
    let fd = new FormData();
    fd.append("type", type);
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }

    try {
      let res = await this.http.post(url, fd, settings);
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async onDeleteFatturaVoce(id, type) {
    const url = `${this.baseUrl}/utility/fattura/voce/${type}/${id}/delete`;

    try {
      const res = await this.http.get(url);

      let message = null;
      if (res && res.data) {
        message =
          res.data.message ||
          (res.data.meta &&
            res.data.meta.status &&
            res.data.meta.status.message) ||
          null;
      }

      return {
        success: true,
        message,
      };
    } catch (err) {
      let message = null;

      if (err && err.response && err.response.data) {
        const data = err.response.data;
        if (typeof data === "string") {
          message = data;
        } else {
          message =
            data.message ||
            (data.meta &&
              data.meta.status &&
              data.meta.status.message) ||
            data.error ||
            null;
        }
      } else if (err && err.message) {
        message = err.message;
      }

      const isVoceInUso =
        message &&
        typeof message === "string" &&
        message.includes("Impossibile eliminare: la voce è in uso");

      if (!isVoceInUso) {
        this.eventBus.emit("data-load-error", { message: err, url });
      }

      return {
        success: false,
        message,
      };
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async caricamentoConsumiFile(file, type) {
    let items = [];
    const settings = { headers: { "content-type": "multipart/form-data" } };
    const url = `${this.baseUrl}/utility/caricamento/consumi/file`;
    let fd = new FormData();
    fd.append("type", type);
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }

    try {
      let res = await this.http.post(url, fd, settings);
      items = res.data;
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async caricamentoLettureFile(file, type) {
    let items = [];
    const settings = { headers: { "content-type": "multipart/form-data" } };
    const url = `${this.baseUrl}/utility/caricamento/letture/file`;
    let fd = new FormData();
    fd.append("type", type);
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }

    try {
      let res = await this.http.post(url, fd, settings);
      items = res.data;
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async showPdfOfferta(id, id_agente) {
    const url = `${this.baseUrlFlussi}/proposta/scarica-pdf-offerta`;
    try {
      let res = await this.http({
        url,
        method: "POST",
        data: {
          offerta_id: id,
          agente: id_agente,
          for_download: true
        },
        responseType: "blob",
      });
      this.filemanager.download(res);
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async updateDateRcu(obj, type) {
    let item = {};

    const url = `${this.baseUrl}/utility/${type}/rcu/date/update`;

    try {
      let res = await this.http.post(url, { obj });

      item = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
      };
    }
  }

  async viewAllLetture(code, type) {
    let items = [];
    const url = `${this.baseUrl}/utility/${type}/all/letture`;

    try {
      let res = await this.http.post(url, { code });

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }
  async setAllVoceFattura(fd, method) {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura/voce/create-all-${method}`;

    try {
      let res = await this.http.post(url, fd);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }
  async getFattureVoce(fd, method) {
    let items = [];
    const url = `${this.baseUrl}/utility/fattura/voce/get-fatture-${method}`;

    try {
      let res = await this.http.post(url, fd);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }
  async getScalaAgenti(id){
    let item = {}

    const url = `${this.baseUrl}/agenti/scala-agenti/${id}`
    try {
      let res = await this.http.get(url)
      
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async viewDocumento_wizard(id, name){
    let item = [];
    const url = `${this.basePraticheUrl}/view-document`
    try {
      const res = await this.http.post(
        url, 
        {
            'matrice_id':id,
            'file':name
        }
      )
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded') 
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }     
    }
  }

  async downloadDocumento_wizard(id, filename){
    const url = `${this.basePraticheUrl}/multisito/download-file-caricamento`
    try {
      let res = await this.http({url,
          method: 'POST',
          data: {
            matrice_id: id,
            file: filename,
            // dir: directory
          },
          responseType: 'blob',
        })
      //this.eventBus.emit('data-load-success', {message: res.data})

      this.filemanager.download(res)

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')   
    }
  }

  async getCaricamentoWizardByMatriceId(id) {
    let item = null

    const url = `${this.basePraticheUrl}/multisito/get-caricamento`

    try {
      let res = await this.http.post(url, { id })
      res = res.data

      if (res?.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        item = res.data
      } else if (res?.item && typeof res.item === 'object' && !Array.isArray(res.item)) {
        item = res.item
      } else if (res && typeof res === 'object' && !Array.isArray(res)) {
        item = res
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getBonus(regione, data){
    let items = [];
    const url = `${this.baseUrl}/AreaFatturazione/get-file-bonus-by-regione/${regione}/${data}`;

    try {
      let res = await this.http.get(url);

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async getFattureBonus(data, includeConsumi = false){
    let items = [];
    const url = `${this.baseUrl}/AreaFatturazione/get-fatture-bonus`;

    try {
      let res = await this.http.post(url, { data, include_consumi: includeConsumi });

      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async generaFileBonusBasilicataRisposta(data, file){
    const url = `${this.baseUrl}/AreaFatturazione/genera-file-bonus-basilicata-risposta`;
    const fd = new FormData();
    fd.append('data', data);
    fd.append('file', file);

    try {
      const res = await this.http.post(url, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        responseType: 'blob',
      });
      this.filemanager.download(res, {
        type: 'text/csv;charset=utf-8'
      });
      return true;
    } catch (err) {
      if (err?.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          err.response.data = JSON.parse(text);
        } catch (parseError) {
          // Mantiene l'errore originale se la risposta non e JSON.
        }
      }
      this.eventBus.emit("data-load-error", { message: err, url });
      throw err;
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async checkFileBonusBasilicataRisposta(data){
    let items = {};
    const url = `${this.baseUrl}/AreaFatturazione/check-file-bonus-basilicata-risposta`;

    try {
      const res = await this.http.post(url, { data });
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
      throw err;
    } finally {
      this.eventBus.emit("data-loaded");
    }

    return items;
  }

  async scaricaFileBonusBasilicataRisposta(data){
    const url = `${this.baseUrl}/AreaFatturazione/scarica-file-bonus-basilicata-risposta`;

    try {
      const res = await this.http.post(url, { data }, {
        responseType: 'blob',
      });
      this.filemanager.download(res, {
        type: 'text/csv;charset=utf-8'
      });
      return true;
    } catch (err) {
      if (err?.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          err.response.data = JSON.parse(text);
        } catch (parseError) {
          // Mantiene l'errore originale se la risposta non e JSON.
        }
      }
      this.eventBus.emit("data-load-error", { message: err, url });
      throw err;
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

}
